import React from 'react';
import {
  Box,
  SimpleGrid,
  Text,
  VStack,
  Heading,
  Icon,
  Flex,
} from '@chakra-ui/react';
import {
  FaCalendarAlt,
  FaUsers,
  FaMoneyBillWave,
  FaUtensils,
  FaMapMarkerAlt,
} from 'react-icons/fa';
import {
  INFO_QUANDO_TITLE,
  INFO_QUANDO_BODY,
  INFO_ETA_TITLE,
  INFO_ETA_BODY,
  INFO_PREZZO_TITLE,
  INFO_PREZZO_BODY,
  INFO_PRANZO_TITLE,
  INFO_PRANZO_BODY,
  INFO_DOVE_TITLE,
  INFO_DOVE_BODY,
  QUICK_INFO_INTRO_TITLE,
  CIL,
  SECTION_TITLE_CONTAINER_BG,
  SECTION_TITLE_TEXT_COLOR,
} from './constants';
import SpotlightCard from '../SpotlightCard';
import './EssentialInfoSection.css';

const cards = [
  {
    tag: INFO_QUANDO_TITLE,
    lines: INFO_QUANDO_BODY,
    icon: FaCalendarAlt,
    iconColor: CIL.sky,
  },
  {
    tag: INFO_ETA_TITLE,
    lines: INFO_ETA_BODY,
    icon: FaUsers,
    iconColor: CIL.plum,
  },
  {
    tag: INFO_PREZZO_TITLE,
    lines: INFO_PREZZO_BODY,
    icon: FaMoneyBillWave,
    iconColor: CIL.teal,
  },
  {
    tag: INFO_PRANZO_TITLE,
    lines: INFO_PRANZO_BODY,
    icon: FaUtensils,
    iconColor: CIL.pink,
  },
  {
    tag: INFO_DOVE_TITLE,
    lines: INFO_DOVE_BODY,
    icon: FaMapMarkerAlt,
    iconColor: CIL.yellow,
  },
];

const SPOTLIGHT_LIGHT = 'rgba(59, 35, 90, 0.06)';

const EssentialInfoSection = () => (
  <Box as="section" py={{ base: 10, md: 14 }}>
    <Box w="100%" maxW="100%" px={{ base: 4, md: 6, lg: 8 }}>
      <Heading as="h2" size="lg" mb={8} textAlign="center">
        <Box
          w="100%"
          px={4}
          py={3}
          borderRadius="lg"
          sx={{ background: SECTION_TITLE_CONTAINER_BG }}
          boxShadow="sm"
        >
          <Text as="span" fontWeight="bold" color={SECTION_TITLE_TEXT_COLOR}>
            {QUICK_INFO_INTRO_TITLE}
          </Text>
        </Box>
      </Heading>
      <SimpleGrid
        columns={{ base: 1, md: 5 }}
        spacing={{ base: 4, md: 3 }}
        className="essential-info-grid"
        w="100%"
        maxW="100%"
      >
        {cards.map(({ tag, lines, icon: IconComponent, iconColor }) => (
          <SpotlightCard
            key={tag}
            className="essential-info-spotlight-card"
            spotlightColor={SPOTLIGHT_LIGHT}
          >
            <Box p={3} textAlign="center">
              <Flex align="center" justify="center" gap={2} mb={2}>
                <Icon
                  as={IconComponent}
                  w={6}
                  h={6}
                  color={iconColor}
                  flexShrink={0}
                />
                <Heading
                  as="h3"
                  size="sm"
                  fontSize={{ base: 'md', md: 'lg' }}
                  color={iconColor}
                  fontWeight="bold"
                >
                  {tag}
                </Heading>
              </Flex>
              <VStack align="center" spacing={1}>
                {lines.map((line) => (
                  <Text
                    key={line}
                    fontSize={
                      line === INFO_DOVE_BODY[0]
                        ? { base: 'md', md: 'md' }
                        : { base: 'sm', md: 'sm' }
                    }
                    color="gray.800"
                    lineHeight="tall"
                    fontWeight={
                      line === INFO_ETA_BODY[0] ||
                      line === INFO_DOVE_BODY[0] ||
                      line === INFO_PREZZO_BODY[3]
                        ? 'bold'
                        : '500'
                    }
                  >
                    {line}
                  </Text>
                ))}
              </VStack>
            </Box>
          </SpotlightCard>
        ))}
      </SimpleGrid>
    </Box>
  </Box>
);

export default EssentialInfoSection;
